import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function My_task() {
    const navigate = useNavigate();
    let trackerWindow = null;
    var selectedteamMemCount = 0;
    const [listAlltaskArray, setListAlltaskArray] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useEffect(() => {

        const userid = localStorage.getItem('member_id');
        var obj = {
            userid: userid,
        }
        $.ajax({
            type: 'POST',
            url: 'getMemberAllTasks.php',
            data: obj,
            cache: false,
            success: function (result) {
                var res = result;
                console.log(res);
                if (res !== 'fail' && res !== '') {
                    var arr = res;
                    var len = arr.length ? arr.length : '0';
                    if (len < 1) {
                        $('.notice_text').css('display', 'block');
                        $('#norecord').css('display', 'block');
                    } else {
                        setListAlltaskArray(arr)
                    }


                } else {
                    showAlert('Cannot found any task for this project.');
                    $('#norecord').css('display', 'block');
                }
            },
        });
    }, []);

    function checksts() {
        var len = listAlltaskArray.length;
        if (len < 1) {
            $('#norecord').css('display', 'block');
        } else {
            console.log(listAlltaskArray);
        }
    }

    function getTasksDetails(pr_key, pro_id, pro_name, tsk_name) {
        localStorage.setItem('redirectto', 'mytask')
        localStorage.setItem('task_name', tsk_name)
        localStorage.setItem('selected_project_name', pro_name);
        localStorage.setItem('taskid', pr_key);
        localStorage.setItem('taskproid', pro_id);
        navigate('/task_details');
    }
    function getCompleteTasksDetails(pr_key, pro_id) {

        localStorage.setItem('taskid', pr_key);
        localStorage.setItem('taskproid', pro_id);
        navigate('/completetask_details');
    }
    function openAddTaskPop() {
        $('#addTsxs').css('display', 'block');
    }
    function clsoetsxPop() {
        $('.loader_inner').css('display', 'none')
        $('#addTsxs').css('display', 'none');
    }

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function removeTask(pr_key) {
        var obj = {
            primary_key: pr_key
        }
        $.ajax({
            type: 'POST',
            url: 'removeProjectTask.php',
            data: obj,
            cache: false,
            success: function (result) {
                if (result != 'fail') {
                    showAlert('Removed successfully');
                    setTimeout(redirectpage, 1500);
                } else {
                    showAlert('Cannot remove task.');
                }
            },
        });
    }

    function startwork(tsk_id, pro_id, proname, tskname, tskdetails) {
        var userid = localStorage.getItem('member_id');
        var pr_key = tsk_id;
        var tsk_name = tskname;
        var mem_name = localStorage.getItem('membername');
        var company_id = localStorage.getItem('mem_company_id');
        var pid = pro_id;
        var active_pro_name = proname;
        var comname = localStorage.getItem('mem_company_name');
        var task_details = tskdetails;
        var comlohgo = localStorage.getItem('companylogo');
        const params = new URLSearchParams({
            task_id: pr_key,
            project_id: pid,
            member_id: userid,
            member_name: mem_name,
            mem_com_id: company_id,
            task_name: tsk_name,
            active_pro_name: active_pro_name,
            comname: comname,
            task_details: task_details,
            comlohgo: comlohgo
        });

        const url = `time_tracker.php?${params.toString()}`;
        if (trackerWindow && !trackerWindow.closed) {
            trackerWindow.focus();
            return;
        }
        trackerWindow = window.open(
            url,
            'timeTrackerWindow',
            'width=420,height=420,resizable=no,alwaysRaised=yes,scrollbars=no,toolbar=no,menubar=no,location=no'
        );
    }

    function redirectpage() {

        navigate('/redirect_mytask');
    }
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Your tasks</h2>
                    <Link className='pull_right add_new_pro' to="/member_create_task">Add New Task</Link>


                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <div className='vl_listing_area_grid'>

                        <div className='vl_listing_row nodisplay' id="norecord">
                            <h1 className='notice_text'> No Record Found</h1>
                        </div>
                        {Array.isArray(listAlltaskArray) &&
                            listAlltaskArray.map((item, index) => {
                                const userid = localStorage.getItem('member_id');
                                const isComplete = item.tsk_status === "complete";
                                const creatorid = item.assignById;
                                console.log(listAlltaskArray)
                                const candelete = !isComplete && Number(creatorid) === Number(userid);

                                return (
                                    <div
                                        key={index}
                                        className="resource_card_one_third_grid"
                                        style={{
                                            backgroundColor: isComplete ? "#d4edda" : "transparent", // light green for complete
                                        }}
                                    >
                                        <div className='resource_inner_grid'>
                                            <div className='fullwidth pull_left pt-21'>
                                                <h3 className="prj_name">{item.taskname}</h3>
                                                <input id="proj_id" type="hidden" value={item.proj_id} />
                                                <input id="tsk_com_id" type="hidden" value={item.tasjk_com_id} />
                                                <input id="tsk_primary_key" type="hidden" value={item.primary_key} />


                                            </div>

                                            <div className="vl_dsh_one_full">
                                                <p>{item.task_details}</p>
                                                <div className="inforow">

                                                    <span>

                                                        {!isComplete && (
                                                            <button
                                                                className="startbutton"
                                                                onClick={() => startwork(item.tsk_id, item.proj_id, item.proname, item.taskname, item.task_details)}
                                                            >
                                                                Start Work
                                                            </button>
                                                        )}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="vl_dsh_one_full">
                                                <p>Project Name: {item.proname}</p>
                                            </div>

                                            <div className="list_buttonholder">
                                                {/* Change function based on completion */}
                                                <button
                                                    onClick={() => {
                                                        isComplete
                                                            ? getCompleteTasksDetails(item.tsk_id, item.proj_id)
                                                            : getTasksDetails(item.tsk_id, item.proj_id, item.proname, item.taskname);
                                                    }}
                                                >
                                                    Details
                                                </button>


                                                {/* Hide delete button if task is complete */}
                                                {candelete && (
                                                    <button
                                                        className="rightgap backtranparent"
                                                        onClick={() => removeTask(item.tsk_id)}
                                                    >
                                                        <i className="ri-delete-bin-3-fill"></i>
                                                    </button>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
